import React, { useEffect, useState } from "react";
import ManageYourBookingTabContent from "./ManageYourBookingTabContent";
import PersonalsTabContent from "./PersonalsTabContent";
import { useGetUserProfileQuery } from "../../../../rtk-query/slices/profile/profileSlice";

function PersonalDetailsTabContent({ setCurrentTab }) {
  const { data: userProfile } = useGetUserProfileQuery();
  const [type, setType] = useState(1);
  const [formState, setFormState] = useState({
    bookingOption: "",
    fullName: "",
    jobTitle: "",
    phoneNumber: "",
    termsAccepted: false,
    companyCertificate: null,
  });

  useEffect(() => {
    if (userProfile?.data) {
      setFormState({
        ...formState,
        fullName: userProfile?.data?.supplier_user_full_name,
        phoneNumber: userProfile?.data?.supplier_user_phone,
        jobTitle: userProfile?.data?.designation && {
          value: userProfile?.data?.designation?.id,
          label: userProfile?.data?.designation?.designation_name,
        },
        bookingOption:
          userProfile?.data?.supplier?.is_online_reservation !== null
            ? userProfile?.data?.supplier?.is_online_reservation === 1
              ? "yes"
              : "no"
            : "",
        termsAccepted: userProfile?.data?.user?.terms_accepted,
      });
    }
  }, [userProfile]);

  const updateFormState = (newState) => {
    setFormState((prevState) => ({ ...prevState, ...newState }));
  };
  return (
    <div>
      {type === 1 ? (
        <ManageYourBookingTabContent
          setCurrentTab={setCurrentTab}
          formState={formState}
          updateFormState={updateFormState}
          setType={setType}
        />
      ) : (
        <PersonalsTabContent
          formState={formState}
          updateFormState={updateFormState}
          setCurrentTab={setCurrentTab}
        />
      )}
    </div>
  );
}

export default PersonalDetailsTabContent;
